var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedianScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.1429V22.8571H18.2857V25.1429H16Z",
    fill: "#0923E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 29.7143V27.4286H16V29.7143H2.28571V0H0V29.7143C0 30.3205 0.240816 30.9019 0.66947 31.3305C1.09812 31.7592 1.67951 32 2.28571 32H32V29.7143H18.2857Z",
    fill: "#0923E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4891 20.2046C27.2366 20.9431 26.7699 21.5898 26.1485 22.0622C25.5271 22.5346 24.7792 22.8113 24 22.8571C21.52 22.8571 20.2149 19.048 18.8343 15.0149C18.4274 13.8274 18.0069 12.6034 17.5337 11.4286H18.2857V9.14286H16.4823C15.0994 6.53143 13.2366 4.57143 10.2857 4.57143C6.08229 4.57143 4.688 8.60914 4.62971 8.78171L6.79657 9.50972C7.04913 8.77115 7.51583 8.12449 8.1372 7.65209C8.75858 7.1797 9.50651 6.90297 10.2857 6.85714C13.6229 6.85714 15.1726 11.3806 16.6709 15.7554C16.9623 16.6034 17.2537 17.4583 17.5646 18.2857H16V20.5714H18.5166C19.7543 23.1874 21.3691 25.1429 24 25.1429C28.2034 25.1429 29.5977 21.1051 29.656 20.9326L27.4891 20.2046ZM16 6.85714V4.57143H18.2857V6.85714H16ZM16 2.28571V0H18.2857V2.28571H16Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedianScore);
export default __webpack_public_path__ + "static/media/median-score.acd1d42baf92e36fc44a43145310bc75.svg";
export { ForwardRef as ReactComponent };